import Cards from './Cards';
import Filter from './Filter';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import { useEffect, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import APIS from '../../constant/Endpoint';
import useGetHook from '../../customHooks/useGetHook';
import { getApiData } from '../../helpers/AxiosInstance';
import { IFilterFleet } from '../../types/interface';
import PieChart from './PieChart';

export default function Overview() {
  const { control, setValue, getValues } = useForm<IFilterFleet>({});
  const [loading, setLoading] = useState(false);
  const { data, isLoading } = useGetHook({
    url: APIS.SUBJECT,
    queryKey: ['subjects'],
    params: {
      is_active: true,
    },
  });
  const filterParams = useWatch({ control });

  const [ticketCounts, setTicketCounts] = useState([]);
  const [totalTicketCount, setTotalTicketCounts] = useState(0);

  const handleGetTicketCount = async (item, filterParams) => {
    const url = APIS.TICKET;
    const param = {
      queue: item?.id,
      status: filterParams?.status?.id,
      priority: filterParams?.priority?.id,
      created__range: filterParams?.created__range,
      limit: 1,
      offset: 0,
    };
    try {
      const res = await getApiData(url, param);
      if (res?.status === 200) {
        return {
          id: item?.name,
          label: item?.name,
          value: res?.data?.count || 0,
          color: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
        };
      }
    } catch (err) {
      console.error(err);
    }
    return {
      id: item?.name,
      label: item?.name,
      value: 0,
      color: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
    };
  };

  useEffect(() => {
    const fetchAllCounts = async () => {
      setLoading(true);
      try {
        if (Array.isArray(data) && data.length > 0) {
          const results = await Promise.all(
            data.map((item) => handleGetTicketCount(item, filterParams))
          );
          setTicketCounts(results);
          const total = results.reduce(
            (acc, curr) => acc + (curr?.value || 0),
            0
          );
          setTotalTicketCounts(total);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllCounts();
  }, [data, filterParams]);

  return (
    <div className={tw`h-fit`}>
      <Filter getValues={getValues} setValue={setValue} control={control} />
      <Cards
        data={ticketCounts}
        isLoading={isLoading || loading}
        totalTicketCount={totalTicketCount}
      />
      <div className={tw`grid grid-cols-1 gap-4`}>
        <PieChart data={ticketCounts} />
      </div>
    </div>
  );
}
